import { ObservableArray, View } from "binder"
import { QuotationListViewModel, item } from "./quotationList-viewModel"

export class QuotationListView extends View<QuotationListViewModel>{
    GetViewUniqueId(): string {
        return "V-B07E6DFC-3CFE-4152-BE62-FF371EC2592E"
    }
    loadHtml(): string {
        let element = require('./quotationList.html').default;
        let style = require('./quotationList.less');
        return element;
    }
    constructor() {
       super();
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set items(v: ObservableArray<item>) { this._items = v; } public get items(): ObservableArray<item> { return this._items;} private _items: ObservableArray<item>;

}
